import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'
import { Label } from '@/shared/components/ui/label'
import { useRedactorStore } from '../store/redactorStore'
import type { Tone, Audience, MessageType } from '../types'

const TONES: { value: Tone; label: string }[] = [
  { value: 'diplomatic', label: 'Diplomatic' },
  { value: 'direct', label: 'Direct' },
  { value: 'formal', label: 'Formal' },
  { value: 'casual', label: 'Casual' },
  { value: 'assertive', label: 'Assertive' },
  { value: 'empathetic', label: 'Empathetic' },
]

const AUDIENCES: { value: Audience; label: string }[] = [
  { value: 'team', label: 'Team' },
  { value: 'manager', label: 'Manager' },
  { value: 'executive', label: 'Executive' },
  { value: 'client', label: 'Client' },
  { value: 'recruiter', label: 'Recruiter' },
  { value: 'peer', label: 'Peer' },
]

const MESSAGE_TYPES: { value: MessageType; label: string }[] = [
  { value: 'slack', label: 'Slack' },
  { value: 'email', label: 'Email' },
  { value: 'pr-comment', label: 'PR Comment' },
  { value: 'performance-review', label: 'Perf Review' },
  { value: 'meeting-notes', label: 'Meeting Notes' },
  { value: 'linkedin', label: 'LinkedIn' },
]

export function ControlPanel() {
  const { tone, audience, messageType, setTone, setAudience, setMessageType } = useRedactorStore()

  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="tone">Tone</Label>
        <Select value={tone} onValueChange={(v) => setTone(v as Tone)}>
          <SelectTrigger id="tone" className="w-40">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {TONES.map((t) => (
              <SelectItem key={t.value} value={t.value}>
                {t.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor="audience">Audience</Label>
        <Select value={audience} onValueChange={(v) => setAudience(v as Audience)}>
          <SelectTrigger id="audience" className="w-40">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {AUDIENCES.map((a) => (
              <SelectItem key={a.value} value={a.value}>
                {a.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor="messageType">Format</Label>
        <Select value={messageType} onValueChange={(v) => setMessageType(v as MessageType)}>
          <SelectTrigger id="messageType" className="w-44">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {MESSAGE_TYPES.map((m) => (
              <SelectItem key={m.value} value={m.value}>
                {m.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
